import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";

interface OnlineStatusProps {
  isOnline: boolean;
  lastSeenAt: string | null;
  showDot?: boolean;
  className?: string;
}

export function OnlineStatus({ isOnline, lastSeenAt, showDot = true, className = "" }: OnlineStatusProps) {
  const getStatusText = () => {
    if (isOnline) {
      return "En ligne";
    }
    
    if (lastSeenAt) {
      const lastSeen = new Date(lastSeenAt);
      const now = new Date();
      const diffMinutes = Math.floor((now.getTime() - lastSeen.getTime()) / (1000 * 60));
      
      if (diffMinutes < 2) {
        return "En ligne";
      } else if (diffMinutes < 60) {
        return `Vu il y a ${diffMinutes} min`;
      } else {
        return `Vu ${formatDistanceToNow(lastSeen, { addSuffix: false, locale: fr })}`;
      }
    }
    
    return "Hors ligne";
  };

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      {showDot && (
        <div className={`w-2 h-2 rounded-full ${isOnline ? "bg-emerald-500" : "bg-muted-foreground/50"}`} />
      )}
      <span className="text-xs text-muted-foreground">{getStatusText()}</span>
    </div>
  );
}
